import React from 'react'
import { Form } from 'semantic-ui-react'
import { Accordion, AccordionItem } from '../../../commonComponents/accordion'
import { ImportShipment } from '../../../containers/importShipment'
import { ExportShipment } from '../../../containers/exportShipment'
import ActorDetailForm from '../../../commonComponents/formComponents/actorDetailForm'
function ItemParties(props) {

  const { isFormDisabled } = props
  const translate = (abc) => {
    return abc
  }
  const CopyFromConsignee = null
  const CopyFromConsigner = null
  return (
    <Form.Group className='float-container mg-t-15' widths='equal'>
      <div
        style={{
          textTransform: 'uppercase',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <strong>PARTIES</strong>
      </div>

      <ExportShipment>
        <Accordion totalItems={2} translate={translate}>
          <AccordionItem
            rightHeader={CopyFromConsigner}
            id='1'
            title='CONSIGNOR'
            translate={translate}
          >
            <ActorDetailForm
              actorType='consigner'
              boxNumber='2'
              disabled={isFormDisabled}
              actorName='CONSIGNOR Name'
            />
          </AccordionItem>
          <AccordionItem
            rightHeader={CopyFromConsignee}
            id='2'
            title='CONSIGNEE'
            translate={translate}
          >
            <ActorDetailForm
              actorType='consignee'
              boxNumber='8'
              disabled={isFormDisabled}
              actorName='CONSIGNEE Name'
            />
          </AccordionItem>
        </Accordion>
      </ExportShipment>

      <ImportShipment>
        <Accordion totalItems={3} translate={translate}>
          <AccordionItem
            rightHeader={CopyFromConsigner}
            id='1'
            title='EXPORTER'
            translate={translate}
          >
            <ActorDetailForm
              actorType='exporter'
              boxNumber='2'
              disabled={isFormDisabled}
              actorName='EXPORTER Name'
            />
          </AccordionItem>
          <AccordionItem rightHeader={CopyFromConsigner} id='1' title='BUYER' translate={translate}>
            <ActorDetailForm
              actorType='buyer'
              boxNumber='2'
              disabled={isFormDisabled}
              actorName='BUYER Name'
            />
          </AccordionItem>
          <AccordionItem
            rightHeader={CopyFromConsignee}
            id='2'
            title='SELLER'
            translate={translate}
          >
            <ActorDetailForm
              actorType='seller'
              boxNumber='8'
              disabled={isFormDisabled}
              actorName='SELLER Name'
            />
          </AccordionItem>
        </Accordion>
      </ImportShipment>
    </Form.Group>
  )
}

export default React.memo(ItemParties)
